export default "__VITE_ASSET__AQmLsgGz__"